import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import MenuBarHome from '../components/Home/MenuBar/MenuBarHome';
import TemplateMenu from '../templates/HomePage/Menu';
import MenuProfile from '../components/MenuProfile/MenuProfile';
import LogoBackground from '../components/LogoBackground';
import { ContainerPages } from '../components/Containers';

export default function HomePage(props) {
  const { userInfo } = useSelector((state) => state.userSign);

  useEffect(() => {
    if (!userInfo) {
      props.history.push('/login');
    }
  }, [userInfo, props.history]);

  return (
    <ContainerPages>
      <MenuProfile />
      <MenuBarHome />
      <TemplateMenu />
      <LogoBackground />
    </ContainerPages>
  );
}
